import { cn } from "@lib/cn";
import { useIsPdf } from "@library/components";
import { forwardRef } from "react";
import { useCarouselCtx } from "../ctx";

interface IProps {
  activeId?: string;
  /** When true, pagination is inline (e.g. in nav row with arrows) instead of absolute */
  inline?: boolean;
}

export const CarouselPagination = forwardRef<HTMLDivElement, IProps>(
  ({ activeId, inline }, ref) => {
    const {
      isFullScreen,
      sets,
      comboSettings: {
        carouselBulletsColor,
        carouselBulletsColorActive,
        carouselBulletsOpacity,
        carouselBulletsOpacityActive,
      },
    } = useCarouselCtx();
    const isPdf = useIsPdf();

    return (
      <div
        className={cn({
          "tw-z-10 tw-flex tw-items-center tw-justify-center": true,
          "tw-absolute tw-bottom-0": !inline,
          "tw-mb-4": isFullScreen && !inline,
        })}
        ref={ref}
        style={{
          // @ts-ignore
          "--carousel-bullet-size": isFullScreen ? "12px" : "8px",
          "--carousel-bullet-active-color": carouselBulletsColorActive,
          "--carousel-bullet-inactive-color": carouselBulletsColor,
          "--carousel-bullet-opacity": carouselBulletsOpacity / 100,
          "--carousel-bullet-opacity-active":
            carouselBulletsOpacityActive / 100,
        }}
      >
        {isPdf &&
          sets.map((set) => (
            <div
              key={set.id}
              className={cn({
                "carousel-bullet": true,
                "carousel-bullet-active": activeId === set.id,
              })}
            />
          ))}
      </div>
    );
  },
);
